import './themes/main.scss';

import { QueryClientProvider } from '@tanstack/react-query';
import { FC } from 'react';
import { Outlet } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { queryClient } from './api/network/queryClient';
import GAListener from './components/Analytics/Analytics';
import { sentryCreateBrowserRouter } from './components/Analytics/SentryIntegration';
import InitialLoading from './components/InitialLoading/InitialLoading';
import { routes } from './routes';

export const App: FC = () => {
  return (
    <GAListener>
      <QueryClientProvider client={queryClient}>
        <Outlet />
      </QueryClientProvider>
    </GAListener>
  );
};

const router = sentryCreateBrowserRouter([
  { path: '/', Component: App, HydrateFallback: InitialLoading, children: routes },
]);

export const AppRoot: FC = () => {
  return <RouterProvider router={router} />;
};
